import {
  initialState,
  Actions,
  State,
  CHANGE_TRACKING,
  CHANGE_TRACKING_SUCCESS,
  CHANGE_TRACKING_ERROR,
  RESET_CHANGE_TRACKING,
} from "../../types/user/change-tracking";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case CHANGE_TRACKING:
      return {
        ...state,
        states: {
          success: false,
          loading: true,
          error: false,
        },
      };
    case CHANGE_TRACKING_SUCCESS:
      return {
        ...state,
        states: {
          success: true,
          loading: false,
          error: false,
        },
      };
    case CHANGE_TRACKING_ERROR:
      return {
        ...state,
        states: {
          success: false,
          loading: false,
          error: action.payload,
        },
      };
    case RESET_CHANGE_TRACKING:
      return {
        ...state,
        states: {
          success: false,
          loading: false,
          error: false,
        },
      };
    default:
      return state;
  }
};

export default reducers;
